import React from 'react';
import QRCode from '../components/QRCode';

function LandingPage() {
  return (
    <div id="landing-page">   
      <QRCode></QRCode>          
    </div>
  )
}

export default LandingPage;